import { render, staticRenderFns } from "./ktabs.vue?vue&type=template&id=21907d5e&scoped=true"
import script from "./ktabs.vue?vue&type=script&lang=js"
export * from "./ktabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21907d5e",
  null
  
)

export default component.exports